import { USER, USER_SESSION } from "../../actions/actionTypes.js";
import { interactiveCreate } from '../../actions/actions.js';

/**
 * copy from https://gitlab.x2sy.com/html5_player/lang-helpers/-/blob/master/src/helper-languages.js
 * @type {Map<string, string>}
 */
const langToLocale = new Map([
	[ 'ua', 'uk' ], // uk-UA
	[ 'ee', 'et' ], // et-EE
	[ 'kz', 'kk' ], // kk-KZ
	[ 'ge', 'ka' ], // ka-GE
	[ 'kg', 'ky' ], // ky-KG
]);

// TODO: rewrite with toolkit slice
export default function userReducer(state = {}, action) {
	switch (action.type) {
		case interactiveCreate.type: {
			const {
				user_info
			} = action.payload;

			user_info.locale = langToLocale.get(user_info.lang) || user_info.lang;

			return {...state, ...user_info};
		}
		case USER:
			return {...state, ...action.payload};

		case USER_SESSION:
			return {...state, session: action.payload};

		default:
			return state;
	}
}
